import styled from 'styled-components';

export const Content = styled.div`
  .buttonWrapper {
    display: flex;
    width: 100%;
    grid-gap: 10px;
    padding: 20px 0 0;
  }

  .inputWrapper {
    display: flex;
    flex-direction: column;
    grid-gap: 20px;

    .select {
      height: 40px;
    }

    .add-more {
      cursor: pointer;
      margin: 5px;
    }

    .csv {
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 130%;
      color: var(--color-link);
      text-decoration: underline;
      cursor: pointer;
    }

    .additional-team {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
  }
`;
